import type { PhotoPoint } from '@/offline/sitePack'

/** What the operator keeps on the phone for a run until Close run (sent with close_run). */
export interface RunDraft {
  /** 'Machine stopped' time. */
  stopped_at: string | null
  /** Settings typed on the Run screen (step registry fields). */
  params: Record<string, string>
  /** Outputs confirmed as 'nothing came out'. */
  zero_streams: string[]
}

export const emptyRunDraft = (): RunDraft => ({ stopped_at: null, params: {}, zero_streams: [] })

export type RunDraftUpdate = (fn: (d: RunDraft) => RunDraft) => void

/** Decorticator photo points; the step registry names each machine type's own. */
export const DEFAULT_PHOTO_POINTS: PhotoPoint[] = [
  { key: 'HOPPER', hi: 'हॉपर की फ़ोटो', en: 'Hopper photo' },
  { key: 'DRUM', hi: 'ड्रम की फ़ोटो', en: 'Drum photo' },
  { key: 'OUTLET', hi: 'आउटलेट की फ़ोटो', en: 'Outlet photo' },
]

